// extracted by mini-css-extract-plugin
export default {"card":"RepoCard_card__UoMmx","title":"RepoCard_title__1Uo0K","stats":"RepoCard_stats__pU-LL","icon":"RepoCard_icon__4GrZz"};